import * as Yup from 'yup'

export const schemaSelectSupplier = (t: (key: string) => string) => ({
  supplier: Yup.mixed().required(t('requiredMessage')),
})
